import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  newPassword: string;
}

export const useUpdateUserPassword = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const updateUser = async (data: Props) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PUT,
      data: { newPassword: data.newPassword },
    });

    const response = await fetch(`${APIBaseChronos}/api/user/password`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to update password');
    }

    return response;
  };

  return useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      toast.success('Password updated successfully');
    },
    onError: () => {
      toast.error('Failed to update password');
    },
  });
};
